import React from 'react'

import { CSSObject } from '@emotion/react'
import styled from '@emotion/styled'
import { Box, Text, TextProps, useTheme } from '@gousto-internal/citrus-react'

import { breakpointToSmall } from '../constants'

// Here we use a 'custom' breakpoint, 'max-width: 374px' which citrus doesn't appear to have
export const ComparisonTableItemContainer = styled(Box)(() => ({
  [breakpointToSmall]: {
    width: '5.5rem',
  },
}))

export const SectionContainer = styled(Box)(() => ({
  [breakpointToSmall]: {
    maxWidth: '18.5rem',
  },
}))

export const BadgeTextContainer = (props: TextProps) => {
  const { theme } = useTheme()
  const Component = styled(Text)(() => ({
    [breakpointToSmall]: {
      fontSize: '12px',
    },
    ...(theme.responsiveStyle(['1rem', '1.25rem'], ['lineHeight']) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

export const ImageContainer = styled(Box)({
  img: {
    width: '100%',
  },
})
